module.exports = __webpack_public_path__ + "img/sim.9a5915c9.svg";